{
  "actionbar.actions": "Eylemler",
  "actionbar.actionsAvailable": "Eylemler mevcut.",
  "actionbar.clearSelection": "Seçimi temizle",
  "actionbar.selected": "{count, plural, =0 {Hiçbiri seçilmedi} other {# seçildi}}",
  "actionbar.selectedAll": "Tümü seçildi",
  "button.pending": "beklemede",
  "contextualhelp.help": "Yardım",
  "contextualhelp.info": "Bilgiler",
  "dialog.alert": "Uyarı",
  "dialog.dismiss": "Kapat",
  "dropzone.replaceMessage": "Değiştirmek için dosyayı bırakın",
  "inlinealert.informative": "Bilgiler",
  "inlinealert.negative": "Hata",
  "inlinealert.notice": "Uyarı",
  "inlinealert.positive": "Başarılı",
  "label.(optional)": "(isteğe bağlı)",
  "label.(required)": "(gerekli)",
  "menu.moreActions": "Daha fazla eylem",
  "picker.placeholder": "Seçin…",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.loading": "Yükleniyor...",
  "table.loadingMore": "Daha fazla yükleniyor...",
  "table.resizeColumn": "Sütunu yeniden boyutlandır",
  "table.sortAscending": "Artan Sıralama",
  "table.sortDescending": "Azalan Sıralama",
  "tag.actions": "Eylemler",
  "tag.hideButtonLabel": "Daha az göster",
  "tag.noTags": "Hiçbiri",
  "tag.showAllButtonLabel": "Tümünü göster ({tagCount, number})",
  "breadcrumbs.more": "Daha Fazla Öğe"
}